import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TablePagination, type TablePaginationProps } from "@mui/material";
import { useTheme } from "styled-components";

export const LibraryTablePagination = (props: TablePaginationProps) => {
  const theme = useTheme();

  return (
    <TablePagination
      rowsPerPageOptions={[10, 25, 50, 100, 200]}
      component="div"
      slotProps={{
        select: {
          IconComponent: ExpandMoreIcon,
        },
      }}
      sx={{
        fontSize: "18px",
        "& .MuiToolbar-root": {
          display: "grid",
          gridTemplateColumns: "auto auto 1fr auto",
          paddingLeft: 0,
          paddingRight: 0,
        },
        "& .MuiTablePagination-spacer": {
          display: "none",
        },
        "& .MuiTablePagination-selectLabel": {
          fontSize: { xs: 14, sm: 16 },
          fontWeight: 500,
          margin: 0,
        },
        "& .MuiSelect-select, & .MuiSelect-select:focus": {
          fontSize: 16,
          borderRadius: "8px",
          border: `1px solid ${theme.colors.redesign.db20}`,
          backgroundColor: theme.colors.white,
          paddingTop: "8px !important",
          paddingBottom: "8px !important",
        },
        "& .MuiInputBase-root": {
          marginRight: "8px",
        },
        "& .MuiTablePagination-displayedRows": {
          fontSize: { xs: 14, sm: 16 },
          fontWeight: 500,
          textAlign: "right",
          margin: 0,
        },
        "& .MuiTablePagination-actions": {
          marginLeft: "8px !important",
        },
        "& .MuiTablePagination-actions .MuiButtonBase-root": {
          marginLeft: "8px",
          borderRadius: "8px",
          padding: "7px",
          border: `1px solid ${theme.colors.redesign.db20}`,
          backgroundColor: theme.colors.white,
          "& svg": {
            transition: ".15s",
          },
          "&.Mui-disabled": {
            backgroundColor: "transparent",
          },
          "&:hover": {
            backgroundColor: theme.colors.redesign.b10,
            color: theme.colors.redesign.b100,
          },
          "&:active": {
            borderColor: theme.colors.redesign.b100,
          },
        },
      }}
      {...props}
    />
  );
};
